import { Box, Tag, Text } from "@chakra-ui/react";
import React from "react";
import { precisionCategoryValueFormatting } from "../../../utils/displayGetters";
import { formatSectionHeader } from "../urlReview/MultipleChoiceSection";



export const ClassificationTagBox = ({classificationEntries, ix, ...rest} : { classificationEntries: any ; ix: number }) => {
    
    if (!classificationEntries || classificationEntries.length === 0) {
        return null; 
      }
      const classificationKey = classificationEntries[0];
      const classifcationValues = [];

      if (Array.isArray(classificationEntries[1])) {
        classifcationValues.push(...classificationEntries[1]);
      }
      if (typeof classificationEntries[1] === "string" || classificationEntries[1] instanceof String) {
        classifcationValues.push(classificationEntries[1]);
      }
      if (classifcationValues.length === 0) {
        return null
      }

      

      return (
        <Box
          key={ix}
          mt={2}
          borderWidth="1px"
          align={"flex-start"}
          width={"99%"}
        >
          <Box margin={2} width={"100%"}>
            <Text fontWeight="medium">
              {`${formatSectionHeader(classificationKey)}: `}
            </Text>
            <Text mt={2} mr={3}>
              {classifcationValues.map((value, iy) => {
                return (
                  <Tag
                    key={iy}
                    size={"md"}
                    variant={"solid"}
                    backgroundColor={"blueInputHover"}
                    _hover={{ backgroundColor: "primary.light" }}
                    color={"text.dark"}
                    borderRadius={14}
                    m={1}
                    py={1}
                    px={2}
                    {...rest}
                  >
                    {precisionCategoryValueFormatting({
                      categoryValue: value,
                      keyValue: classificationKey,
                    })}
                  </Tag>
                );
              })}
            </Text>
          </Box>
        </Box>
      );
    }

